module.exports = __webpack_public_path__ + "static/media/img_grip.742fcb3b.png";